import { config } from "../../config";

export const InitialSearchStates = {
  projects: {
    data: config.inProd ? [] : config.mocks.projects,
    query: "",
    pagination: config.inProd
      ? {
          total: 0,
          totalPages: 0,
          currentPage: 1,
          limit: 3,
          hasNextPage: false,
          hasPrevPage: false,
        }
      : config.mocks.searchState.pagination,
    filters: config.inProd
      ? {
          companyName: "",
          growthStage: "",
          productStage: "",
          dateFrom: undefined,
          dateTo: undefined,
        }
      : config.mocks.searchState.filters,
    sorting: config.inProd
      ? {
          sortBy: "createdAt",
          sortOrder: -1,
        }
      : config.mocks.searchState.sorting,
  },
  icps: {
    data: config.inProd ? [] : config.mocks.icps,
    query: "",
    pagination: config.inProd
      ? {
          total: 0,
          totalPages: 0,
          currentPage: 1,
          limit: 3,
          hasNextPage: false,
          hasPrevPage: false,
        }
      : config.mocks.searchState.pagination,
    filters: config.inProd
      ? {
          status: "all",
          platform: "",
          sortBy: "createdAt",
          dateFrom: undefined,
          dateTo: undefined,
        }
      : config.mocks.searchState.filters,
    sorting: config.inProd
      ? {
          sortBy: "createdAt",
          sortOrder: -1,
        }
      : config.mocks.searchState.sorting,
  },
  strategies: {
    data: config.inProd ? [] : config.mocks.strategies,
    query: "",
    pagination: config.inProd
      ? {
          total: 0,
          totalPages: 0,
          currentPage: 1,
          limit: 3,
          hasNextPage: false,
          hasPrevPage: false,
        }
      : config.mocks.searchState.pagination,
    filters: config.inProd
      ? {
          status: "all",
          platform: "all",
          dateFrom: undefined,
          dateTo: undefined,
        }
      : config.mocks.searchState.filters,
    sorting: config.inProd
      ? {
          sortBy: "createdAt",
          sortOrder: -1,
        }
      : config.mocks.searchState.sorting,
  },
  insights: {
    data: config.inProd ? [] : config.mocks.insights,
    query: "",
    pagination: config.inProd
      ? {
          total: 0,
          totalPages: 0,
          currentPage: 1,
          limit: 3,
          hasNextPage: false,
          hasPrevPage: false,
        }
      : config.mocks.searchState.pagination,
    filters: config.inProd
      ? {
          companyName: "",
          growthStage: "",
          productStage: "",
          dateFrom: undefined,
          dateTo: undefined,
        }
      : config.mocks.searchState.filters,
    sorting: config.inProd
      ? {
          sortBy: "createdAt",
          sortOrder: -1,
        }
      : config.mocks.searchState.sorting,
  },
  competitiveAnalysis: {
    data: config.inProd ? [] : config.mocks.competitiveAnalysisReports,
    query: "",
    pagination: config.inProd
      ? {
          total: 0,
          totalPages: 0,
          currentPage: 1,
          limit: 3,
          hasNextPage: false,
          hasPrevPage: false,
        }
      : config.mocks.searchState.pagination,
    filters: config.inProd
      ? {
          dateFrom: undefined,
          dateTo: undefined,
        }
      : config.mocks.searchState.filters,
    sorting: config.inProd
      ? {
          sortBy: "createdAt",
          sortOrder: -1,
        }
      : config.mocks.searchState.sorting,
  },
} as const;
